import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';
@Component({
  selector: 'app-copy-leg-modal',
  templateUrl: './copy-leg-modal.component.html',
  styleUrls: ['./copy-leg-modal.component.scss']
})
export class CopyLegModalComponent implements OnInit {
  @Input() isModalOpened = false;
  @Input() productType: string;
  @Output() copyLegOpenChanged = new EventEmitter<boolean>();
  @Output() copyLeg = new EventEmitter<boolean>();

  form: FormGroup;
  productTypeOptions: string[] = [];

  constructor(
    private fb: FormBuilder,
    private productsConfigService: ProductsConfigService
  ) {
    this.form = this.fb.group({
      productType: this.fb.control('', [Validators.required])
    });
  }

  modalChanged(event) {
    this.copyLegOpenChanged.emit(event);
  }

  copyLegSelected() {
    this.copyLeg.emit(this.form.get('productType').value);
    this.copyLegOpenChanged.emit(false);
  }

  ngOnInit() {
    // populate dropdown
    this.productTypeOptions =
      this.productsConfigService.productInfo.productSpecifications.map(x => {
        return x.productType.longName;
      });
    let selectedProductType =
      this.productsConfigService.productInfo.productSpecifications.filter(
        x => x.productType.shortName === this.productType
      )[0];

    this.form
      .get('productType')
      .setValue(selectedProductType.productType.longName);
  }
}
